import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BASE_URL from '../config';
import Swal from 'sweetalert2';
import Sidebarpo from './Sidebarpo';


const PoByCustomer = () => {
  const [selectedClient, setSelectedClient] = useState('');
  const [poData, setPoData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const latestUpdateOptions = [
    "Po Received From Client",
    "Po issued to supplier",
    "Po Under Progress",
    "Po Shipped",
    "Invoice Issue",
    "Payment Received",
    "Po Closed",
  ];
  
  const supplierPaymentOptions = [
    "Advance With Order",
    "Advance Before Dispatch",
    "OnCredit",
    "Stage Payment",
  ];
  
  const clientPaymentOptions = [
    "Payment Received",
    "Payment Pending",
    "Performer Payment",
  ];
  
  const getBackgroundColor = (value) => {
    switch (value) {
      case "Po Received From Client": return "#ffe6cc";
      case "Po issued to supplier": return "#ffcccc";
      case "Po Under Progress": return "#ffffcc";
      case "Po Shipped": return "#ccffcc";
      case "Invoice Issue": return "#ccccff";
      case "Payment Received": return "#d9edf7";
      case "Po Closed": return "#dff0d8";
  
      case "Advance With Order": return "#f2dede";
      case "Advance Before Dispatch": return "#fcf8e3";
      case "OnCredit": return "#d9edf7";
      case "Stage Payment": return "#dff0d8";
  
      case "Payment Pending": return "#f9d6d5";
      case "Performer Payment": return "#e3f2fd";
      default: return "#ffffff";
    }
  };

  useEffect(() => {
    fetchPOData();
  }, []);

  const fetchPOData = () => {
    axios.get(`${BASE_URL}/api/get-po-data`)
      .then((response) => {
        setPoData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching PO data:', error);
      });
  };

   const handleStatusChange = async (id, field, value) => {
      try {
        await axios.put(`${BASE_URL}/api/update-po/${id}`, {
          [field]: value,
        });
        fetchPOData(); // Refresh table
        Swal.fire('Updated', `${field.replace('_', ' ')} updated successfully`, 'success');
      } catch (error) {
        console.error("Error updating field:", error);
        Swal.fire('Error', 'Something went wrong', 'error');
      }
    };

  const filteredData = selectedClient
  ? poData.filter(po => po.client_name?.toLowerCase() === selectedClient.toLowerCase())
  : [];


  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const getPaginationGroup = () => {
    let start = Math.floor((currentPage - 1) / 5) * 5;
    return new Array(Math.min(5, totalPages - start)).fill().map((_, i) => start + i + 1);
  };

  // Get all unique client names
  const uniqueClientsMap = new Map();
  poData.forEach(po => {
    const lower = po.client_name?.toLowerCase();
    if (lower && !uniqueClientsMap.has(lower)) {
      uniqueClientsMap.set(lower, po.client_name); // preserve original casing
    }
  });
  const uniqueClients = Array.from(uniqueClientsMap.values());
  
  return (
    <div className='row'>
        <div className="custom-2-5">

      <Sidebarpo />
      </div>
      <div className="custom-9-5 dashboardsclooer p-4">
        <h2 className="text-xl font-bold mb-4">PO by Customer</h2>

        


        <div className="form-group mb-4">
            <label htmlFor="clientSelect">Select Client</label>
            <select
              className="form-control"
              id="clientSelect"
              style={{ height: '50px' }}
              value={selectedClient}
          onChange={(e) => {
            setSelectedClient(e.target.value);
            setCurrentPage(1); // reset pagination when client changes
          }}
            >
              <option value="">-- Select Client --</option>
              {uniqueClients.map((client, index) => (
            <option key={index} value={client}>{client}</option>
          ))}
            </select>
          </div>

        {selectedClient && (
          <>
           <div className="table-responsive" style={{ background: '#fff' }}>
            <table className="table table-borderless custom-table">
              <thead>
                <tr>
                  <th>Client Name</th>
                  <th>Client PO Number</th>
                  <th>Client PO Date</th>
                  <th>Item Description </th>
                  <th>Client PO Value</th>
                  <th>Currency</th>
                  <th>Client Delivery Date</th>
                  <th>Supplier PO Number</th>
                  <th>Supplier PO Value</th>
                  <th>Currency</th>
                  {/* <th>Fulfillment (Flow)</th> */}
                  <th>Supplier Name</th>
                  <th>Latest Update</th>
                  <th>Pearlcon Contact</th>
                  <th>Supplier Payment</th>
                  <th>Supplier Delivery Date</th>
                  <th>Client Payment</th>
                  <th> Current Status</th>
                  <th>RFQ Number</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((po, index) => (
                  <tr key={index}>
                    <td>{po.client_name || '-'}</td>
                    <td>{po.client_po_number || '-'}</td>
                    <td>{po.client_po_date || '-'}</td>
                    <td>{po.items_description || '-'}</td>
                    <td>{po.client_po_value || '-'}</td>
                    <td>{po.c_currency || '-'}</td>
                    <td>{po.client_delivery_date || '-'}</td>
                    <td>{po.supplier_po_number || '-'}</td>
                    {/* <td>
                      <div className="d-flex justify-content-between fulfillment-flow">
                        <div className="flow-step completed">
                          <div className="bar"></div>
                          <small>Responded</small>
                        </div>
                        <div className="flow-step completed">
                          <div className="bar"></div>
                          <small>Evaluated</small>
                        </div>
                        <div className="flow-step pending">
                          <div className="bar"></div>
                          <small>Awarded</small>
                        </div>
                      </div>
                    </td> */}
                    <td>{po.supplier_po_value || '-'}</td>
                    <td>{po.currency || '-'}</td>
                    <td>{po.supplier_name || '-'}</td>
                    <td>
  <select
    value={po.latest_update || ""}
    style={{ backgroundColor: getBackgroundColor(po.latest_update), padding: '4px' }}
    onChange={(e) => handleStatusChange(po.id, 'latest_update', e.target.value)}
  >
    <option value="">-- Select --</option>
    {latestUpdateOptions.map((opt) => (
      <option key={opt} value={opt}>{opt}</option>
    ))}
  </select>
</td>
                    <td>{po.pearlcon_contact || '-'}</td>

                    <td>
  <select
    value={po.supplier_payment || ""}
    style={{ backgroundColor: getBackgroundColor(po.supplier_payment), padding: '4px' }}
    onChange={(e) => handleStatusChange(po.id, 'supplier_payment', e.target.value)}
  >
    <option value="">-- Select --</option>
    {supplierPaymentOptions.map((opt) => (
      <option key={opt} value={opt}>{opt}</option>
    ))}
  </select>
</td>
                    <td>{po.supplier_delivery_date || '-'}</td>
                    <td>
  <select
    value={po.client_payment || ""}
    style={{ backgroundColor: getBackgroundColor(po.client_payment), padding: '4px' }}
    onChange={(e) => handleStatusChange(po.id, 'client_payment', e.target.value)}
  >
    <option value="">-- Select --</option>
    {clientPaymentOptions.map((opt) => (
      <option key={opt} value={opt}>{opt}</option>
    ))}
  </select>
</td>
                    <td>{po.current_status || '-'}</td>
                    <td>{po.rfq_number   || '-'}</td>
                   
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="mt-3 d-flex justify-content-center">
              <nav>
                <ul className="pagination">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>
                      &laquo;
                    </button>
                  </li>

                  {getPaginationGroup().map((pageNumber) => (
                    <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(pageNumber)}>
                        {pageNumber}
                      </button>
                    </li>
                  ))}

                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>
                      &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
          </>
        )}
      </div>
    </div>
  );
};

export default PoByCustomer;

